import React from 'react';
import styles from './Heading.module.scss';
import className from 'classnames/bind';
import { RichText } from '../RichText/RichText';

let cx = className.bind(styles);

export function Heading({ level = 'h1', children, className, id, textAlign, style }) {
	const Tag = ({ ...props }) => React.createElement(level, props);
	const childrenIsString = typeof children === 'string';
  const classNameArray = className?.split(' ') || [];

	return (
		<>
			{childrenIsString ? (
				<RichText elem={level} id={id} className={cx(['ns_heading', ...classNameArray, textAlign && `textAlign-${textAlign}`])} style={style} html={children} />
			) : (
				<Tag id={id} className={cx(['ns_heading', ...classNameArray, textAlign && `textAlign-${textAlign}`])} style={style}>
					{children}
				</Tag>
			)}
		</>
	);
}
